import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateWalletBalance } from "../../services/walletService";


const initialState = {
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
};

export const updateWalletBalanceAsync = createAsyncThunk(
  "wallet/updateBalance",
  async (walletData, { rejectWithValue }) => {
    try {
      const response = await updateWalletBalance(walletData);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to add payment";
      return rejectWithValue(errorMessage);
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWalletUpdate: (state) => {
      state.updateLoading = false;
      state.updateSuccess = false;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateWalletBalanceAsync.pending, (state) => {
        state.updateLoading = true;
        state.updateSuccess = false;
        state.updateError = null;
      })
      .addCase(updateWalletBalanceAsync.fulfilled, (state) => {
        state.updateLoading = false;
        state.updateSuccess = true;
      })
      .addCase(updateWalletBalanceAsync.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = false;
        state.updateError = action.payload;
      });
  },
});

export const { resetWalletUpdate } = walletSlice.actions;
export default walletSlice.reducer;
